export default "__VITE_ASSET__c580e8b4__"